export default [
  { name: 'Afganistan', id: 'AF' },
  { name: 'Albania', id: 'AL' },
  { name: 'Algieria', id: 'DZ' },
  { name: 'Andora', id: 'AD' },
  { name: 'Angola', id: 'AO' },
  { name: 'Anguilla', id: 'AI' },
  { name: 'Antarktyka', id: 'AQ' },
  { name: 'Antigua i Barbuda', id: 'AG' },
  { name: 'Arabia Saudyjska', id: 'SA' },
  { name: 'Argentyna', id: 'AR' },
  { name: 'Armenia', id: 'AM' },
  { name: 'Aruba', id: 'AW' },
  { name: 'Australia', id: 'AU' },
  { name: 'Austria', id: 'AT' },
  { name: 'Azerbejdżan', id: 'AZ' },
  { name: 'Bahamy', id: 'BS' },
  { name: 'Bahrajn', id: 'BH' },
  { name: 'Bangladesz', id: 'BD' },
  { name: 'Barbados', id: 'BB' },
  { name: 'Belgia', id: 'BE' },
  { name: 'Belize', id: 'BZ' },
  { name: 'Benin', id: 'BJ' },
  { name: 'Bermudy', id: 'BM' },
  { name: 'Bhutan', id: 'BT' },
  { name: 'Białoruś', id: 'BY' },
  { name: 'Boliwia', id: 'BO' },
  { name: 'Bośnia i Hercegowina', id: 'BA' },
  { name: 'Botswana', id: 'BW' },
  { name: 'Brazylia', id: 'BR' },
  { name: 'Brunei Darussalam', id: 'BN' },
  { name: 'Brytyjskie Terytorium Oceanu Indyjskiego', id: 'IO' },
  { name: 'Brytyjskie Wyspy Dziewicze', id: 'VG' },
  { name: 'Bułgaria', id: 'BG' },
  { name: 'Burkina Faso', id: 'BF' },
  { name: 'Burundi', id: 'BI' },
  { name: 'Ceuta i Melilla', id: 'EA' },
  { name: 'Chile', id: 'CL' },
  { name: 'Chiny', id: 'CN' },
  { name: 'Chorwacja', id: 'HR' },
  { name: 'Côte d’Ivoire', id: 'CI' },
  { name: 'Curaçao', id: 'CW' },
  { name: 'Cypr', id: 'CY' },
  { name: 'Czad', id: 'TD' },
  { name: 'Czarnogóra', id: 'ME' },
  { name: 'Czechy', id: 'CZ' },
  { name: 'Dalekie Wyspy Mniejsze Stanów Zjednoczonych', id: 'UM' },
  { name: 'Dania', id: 'DK' },
  { name: 'Demokratyczna Republika Konga', id: 'CD' },
  { name: 'Diego Garcia', id: 'DG' },
  { name: 'Dominika', id: 'DM' },
  { name: 'Dominikana', id: 'DO' },
  { name: 'Dżibuti', id: 'DJ' },
  { name: 'Egipt', id: 'EG' },
  { name: 'Ekwador', id: 'EC' },
  { name: 'Erytrea', id: 'ER' },
  { name: 'Estonia', id: 'EE' },
  { name: 'Etiopia', id: 'ET' },
  { name: 'Falklandy', id: 'FK' },
  { name: 'Fidżi', id: 'FJ' },
  { name: 'Filipiny', id: 'PH' },
  { name: 'Finlandia', id: 'FI' },
  { name: 'Francja', id: 'FR' },
  { name: 'Francuskie Terytoria Południowe', id: 'TF' },
  { name: 'Gabon', id: 'GA' },
  { name: 'Gambia', id: 'GM' },
  { name: 'Georgia Południowa i Sandwich Południowy', id: 'GS' },
  { name: 'Ghana', id: 'GH' },
  { name: 'Gibraltar', id: 'GI' },
  { name: 'Grecja', id: 'GR' },
  { name: 'Grenada', id: 'GD' },
  { name: 'Grenlandia', id: 'GL' },
  { name: 'Gruzja', id: 'GE' },
  { name: 'Guam', id: 'GU' },
  { name: 'Gujana', id: 'GY' },
  { name: 'Gujana Francuska', id: 'GF' },
  { name: 'Gwadelupa', id: 'GP' },
  { name: 'Gwatemala', id: 'GT' },
  { name: 'Gwinea', id: 'GN' },
  { name: 'Gwinea Bissau', id: 'GW' },
  { name: 'Gwinea Równikowa', id: 'GQ' },
  { name: 'Haiti', id: 'HT' },
  { name: 'Hiszpania', id: 'ES' },
  { name: 'Holandia', id: 'NL' },
  { name: 'Honduras', id: 'HN' },
  { name: 'Indie', id: 'IN' },
  { name: 'Indonezja', id: 'ID' },
  { name: 'Irak', id: 'IQ' },
  { name: 'Iran', id: 'IR' },
  { name: 'Irlandia', id: 'IE' },
  { name: 'Islandia', id: 'IS' },
  { name: 'Izrael', id: 'IL' },
  { name: 'Jamajka', id: 'JM' },
  { name: 'Japonia', id: 'JP' },
  { name: 'Jemen', id: 'YE' },
  { name: 'Jordania', id: 'JO' },
  { name: 'Kajmany', id: 'KY' },
  { name: 'Kambodża', id: 'KH' },
  { name: 'Kamerun', id: 'CM' },
  { name: 'Kanada', id: 'CA' },
  { name: 'Katar', id: 'QA' },
  { name: 'Kazachstan', id: 'KZ' },
  { name: 'Kenia', id: 'KE' },
  { name: 'Kirgistan', id: 'KG' },
  { name: 'Kiribati', id: 'KI' },
  { name: 'Kolumbia', id: 'CO' },
  { name: 'Komory', id: 'KM' },
  { name: 'Kongo', id: 'CG' },
  { name: 'Korea Południowa', id: 'KR' },
  { name: 'Korea Północna', id: 'KP' },
  { name: 'Kosowo', id: 'XK' },
  { name: 'Kostaryka', id: 'CR' },
  { name: 'Kuba', id: 'CU' },
  { name: 'Kuwejt', id: 'KW' },
  { name: 'Laos', id: 'LA' },
  { name: 'Lesotho', id: 'LS' },
  { name: 'Liban', id: 'LB' },
  { name: 'Liberia', id: 'LR' },
  { name: 'Libia', id: 'LY' },
  { name: 'Liechtenstein', id: 'LI' },
  { name: 'Litwa', id: 'LT' },
  { name: 'Luksemburg', id: 'LU' },
  { name: 'Łotwa', id: 'LV' },
  { name: 'Macedonia', id: 'MK' },
  { name: 'Madagaskar', id: 'MG' },
  { name: 'Majotta', id: 'YT' },
  { name: 'Malawi', id: 'MW' },
  { name: 'Malediwy', id: 'MV' },
  { name: 'Malezja', id: 'MY' },
  { name: 'Mali', id: 'ML' },
  { name: 'Malta', id: 'MT' },
  { name: 'Mariany Północne', id: 'MP' },
  { name: 'Maroko', id: 'MA' },
  { name: 'Martynika', id: 'MQ' },
  { name: 'Mauretania', id: 'MR' },
  { name: 'Mauritius', id: 'MU' },
  { name: 'Meksyk', id: 'MX' },
  { name: 'Mikronezja', id: 'FM' },
  { name: 'Mjanma (Birma)', id: 'MM' },
  { name: 'Mołdawia', id: 'MD' },
  { name: 'Monako', id: 'MC' },
  { name: 'Mongolia', id: 'MN' },
  { name: 'Montserrat', id: 'MS' },
  { name: 'Mozambik', id: 'MZ' },
  { name: 'Namibia', id: 'NA' },
  { name: 'Nauru', id: 'NR' },
  { name: 'Nepal', id: 'NP' },
  { name: 'Niderlandy Karaibskie', id: 'BQ' },
  { name: 'Niemcy', id: 'DE' },
  { name: 'Niger', id: 'NE' },
  { name: 'Nigeria', id: 'NG' },
  { name: 'Nikaragua', id: 'NI' },
  { name: 'Niue', id: 'NU' },
  { name: 'Norfolk', id: 'NF' },
  { name: 'Norwegia', id: 'NO' },
  { name: 'Nowa Kaledonia', id: 'NC' },
  { name: 'Nowa Zelandia', id: 'NZ' },
  { name: 'Oman', id: 'OM' },
  { name: 'Pakistan', id: 'PK' },
  { name: 'Palau', id: 'PW' },
  { name: 'Panama', id: 'PA' },
  { name: 'Papua-Nowa Gwinea', id: 'PG' },
  { name: 'Paragwaj', id: 'PY' },
  { name: 'Peru', id: 'PE' },
  { name: 'Pitcairn', id: 'PN' },
  { name: 'Polinezja Francuska', id: 'PF' },
  { name: 'Polska', id: 'PL' },
  { name: 'Portoryko', id: 'PR' },
  { name: 'Portugalia', id: 'PT' },
  { name: 'Republika Południowej Afryki', id: 'ZA' },
  { name: 'Republika Środkowoafrykańska', id: 'CF' },
  { name: 'Republika Zielonego Przylądka', id: 'CV' },
  { name: 'Reunion', id: 'RE' },
  { name: 'Rosja', id: 'RU' },
  { name: 'Rumunia', id: 'RO' },
  { name: 'Rwanda', id: 'RW' },
  { name: 'Sahara Zachodnia', id: 'EH' },
  { name: 'Saint Kitts i Nevis', id: 'KN' },
  { name: 'Saint Lucia', id: 'LC' },
  { name: 'Saint Vincent i Grenadyny', id: 'VC' },
  { name: 'Saint-Barthélemy', id: 'BL' },
  { name: 'Saint-Martin', id: 'MF' },
  { name: 'Saint-Pierre i Miquelon', id: 'PM' },
  { name: 'Salwador', id: 'SV' },
  { name: 'Samoa', id: 'WS' },
  { name: 'Samoa Amerykańskie', id: 'AS' },
  { name: 'San Marino', id: 'SM' },
  { name: 'Senegal', id: 'SN' },
  { name: 'Serbia', id: 'RS' },
  { name: 'Seszele', id: 'SC' },
  { name: 'Sierra Leone', id: 'SL' },
  { name: 'Singapur', id: 'SG' },
  { name: 'Sint Maarten', id: 'SX' },
  { name: 'Słowacja', id: 'SK' },
  { name: 'Słowenia', id: 'SI' },
  { name: 'Somalia', id: 'SO' },
  { name: 'SRA Hongkong (Chiny)', id: 'HK' },
  { name: 'SRA Makau (Chiny)', id: 'MO' },
  { name: 'Sri Lanka', id: 'LK' },
  { name: 'Stany Zjednoczone', id: 'US' },
  { name: 'Suazi', id: 'SZ' },
  { name: 'Sudan', id: 'SD' },
  { name: 'Sudan Południowy', id: 'SS' },
  { name: 'Surinam', id: 'SR' },
  { name: 'Svalbard i Jan Mayen', id: 'SJ' },
  { name: 'Syria', id: 'SY' },
  { name: 'Szwajcaria', id: 'CH' },
  { name: 'Szwecja', id: 'SE' },
  { name: 'Tadżykistan', id: 'TJ' },
  { name: 'Tajlandia', id: 'TH' },
  { name: 'Tajwan', id: 'TW' },
  { name: 'Tanzania', id: 'TZ' },
  { name: 'Terytoria Palestyńskie', id: 'PS' },
  { name: 'Timor Wschodni', id: 'TL' },
  { name: 'Togo', id: 'TG' },
  { name: 'Tokelau', id: 'TK' },
  { name: 'Tonga', id: 'TO' },
  { name: 'Tristan da Cunha', id: 'TA' },
  { name: 'Trynidad i Tobago', id: 'TT' },
  { name: 'Tunezja', id: 'TN' },
  { name: 'Turcja', id: 'TR' },
  { name: 'Turkmenistan', id: 'TM' },
  { name: 'Turks i Caicos', id: 'TC' },
  { name: 'Tuvalu', id: 'TV' },
  { name: 'Uganda', id: 'UG' },
  { name: 'Ukraina', id: 'UA' },
  { name: 'Urugwaj', id: 'UY' },
  { name: 'Uzbekistan', id: 'UZ' },
  { name: 'Vanuatu', id: 'VU' },
  { name: 'Wallis i Futuna', id: 'WF' },
  { name: 'Watykan', id: 'VA' },
  { name: 'Wenezuela', id: 'VE' },
  { name: 'Węgry', id: 'HU' },
  { name: 'Wielka Brytania', id: 'GB' },
  { name: 'Wietnam', id: 'VN' },
  { name: 'Włochy', id: 'IT' },
  { name: 'Wyspa Bożego Narodzenia', id: 'CX' },
  { name: 'Wyspa Guernsey', id: 'GG' },
  { name: 'Wyspa Jersey', id: 'JE' },
  { name: 'Wyspa Man', id: 'IM' },
  { name: 'Wyspa Świętej Heleny', id: 'SH' },
  { name: 'Wyspa Wniebowstąpienia', id: 'AC' },
  { name: 'Wyspy Alandzkie', id: 'AX' },
  { name: 'Wyspy Cooka', id: 'CK' },
  { name: 'Wyspy Dziewicze Stanów Zjednoczonych', id: 'VI' },
  { name: 'Wyspy Kanaryjskie', id: 'IC' },
  { name: 'Wyspy Kokosowe', id: 'CC' },
  { name: 'Wyspy Marshalla', id: 'MH' },
  { name: 'Wyspy Owcze', id: 'FO' },
  { name: 'Wyspy Salomona', id: 'SB' },
  { name: 'Wyspy Świętego Tomasza i Książęca', id: 'ST' },
  { name: 'Zambia', id: 'ZM' },
  { name: 'Zimbabwe', id: 'ZW' },
  { name: 'Zjednoczone Emiraty Arabskie', id: 'AE' },
]
